var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMyFavorites = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 15",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 0h6l2 1.875h8c1.1 0 2 .844 2 1.875v9.375C20 14.156 19.1 15 18 15H2c-1.1 0-2-.844-2-1.875l.01-11.25C.01.844.9 0 2 0Zm7.42 11.496L10 12l.58-.5.016-.013C12.646 9.709 14 8.537 14 7.098 14 5.923 13.032 5 11.8 5c-.696 0-1.364.309-1.8.797A2.444 2.444 0 0 0 8.2 5C6.968 5 6 5.923 6 7.098c0 1.44 1.358 2.615 3.415 4.394l.005.004Z",
  fill: "currentColor"
})));
export default SvgMyFavorites;